<template>
  <div class="live-blog">
    <div v-if="entries.length > 0">
      <h3 class="live-blog-heading">Live Blog Entries</h3>
      <div v-for="entry in entries" :key="entry" v-html="entry" class="entry">
        <a
          v-if="entries.length !== allEntries.length"
          class="live-blog-archive-link"
          @click="pageNum++"
        >View older entries</a>
      </div>
    </div>
  </div>
</template>

<script>
import db from '../db';
import helpers from '../helpers';

export default {
  name: 'LiveBlog',
  data() {
    return {
      allEntries: [],
      paged: true,
      entriesPerPage: 10,
      pageNum: 1,
    };
  },
  firebase: helpers.getFirebaseObject(db),
  watch: {
    speakers: (oldSpeakers, newSpeakers) => {
      this.updateLiveBlog();
    },
  },
  mounted() {
    setInterval(() => { this.updateLiveBlog(); }, 5000);
  },
  computed: {
    entries() {
      let entriesToShow = this.entriesPerPage * this.pageNum;
      return this.allEntries.slice(0, entriesToShow);
    },
  },
  methods: {
    updateLiveBlog() {
      let entries = this.getAllEntries();
      if (entries !== this.allEntries) this.allEntries = entries;
    },
    getAllEntries() {
      if (!this.speakers) return [];
      return helpers.getLiveBlogEntries(this.speakers, this.options);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.live-blog {
  max-height: 530px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
@media screen and (max-width: 942px) {
  .live-blog {
    margin-top: 20px;
    margin-bottom: 20px;
    max-height: unset;
    overflow-y: unset;
  }
}
.live-blog-heading {
  color: #aaa;
}
.entry {
  box-shadow: #ccc 0px 0px 3px;
  padding: 16px;
}
.entry:nth-child(even) {
  background: #efefef;
}
.live-blog-archive-link {
  display: block;
  width: 100%;
  line-height: 3em;
  text-align: center;
  background: #3c3969;
  box-shadow: #ccc 0px 0px 3px;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
}
.live-blog-archive-link:hover {
  background: #282472;
}
</style>



// WEBPACK FOOTER //
// src/components/LiveBlog.vue